import React from 'react';

export default function BacBlock6Roles() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-surface border-b border-line">
      <div className="max-w-[1000px] mx-auto">
        <div className="mb-24 max-w-3xl">
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            La máquina coordina, el humano decide.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            Los sistemas operan lo seguro, el Operador BAC maneja excepciones y la IA asiste. El TENS registra y el Clínico toma las verdaderas decisiones asistenciales.
          </p>
        </div>
        <div className="max-w-[1024px] mx-auto flex flex-col md:flex-row gap-16 lg:gap-24">
          <div className="flex-1 flex flex-col">
            <div className="text-[14px] font-semibold text-ink-soft/70 mb-8 border-b border-line pb-2">
              Operación BAC
            </div>
            <div className="w-full flex flex-col gap-8">
              <div className="flex flex-col">
                <div className="text-[16px] font-bold text-ink mb-1">Sistema / IA</div>
                <div className="text-[14px] text-ink-soft leading-relaxed">Ejecuta reglas seguras, interpreta, resume y sugiere acciones.</div>
              </div>
              <div className="flex flex-col">
                <div className="text-[16px] font-bold text-ink mb-1">Operador BAC</div>
                <div className="text-[14px] text-ink-soft leading-relaxed">Maneja excepciones, autoriza prioridades y resuelve fricción operacional.</div>
              </div>
            </div>
          </div>
          <div className="flex-1 flex flex-col">
            <div className="text-[14px] font-semibold text-brand mb-8 border-b border-line pb-2">
              Atención Clínica (APS)
            </div>
            <div className="w-full flex flex-col gap-8">
              <div className="flex flex-col">
                <div className="text-[16px] font-bold text-ink mb-1">TENS / Técnico</div>
                <div className="text-[14px] text-ink-soft leading-relaxed">Registra prestaciones, mediciones y signos vitales.</div>
              </div>
              <div className="flex flex-col">
                <div className="text-[16px] font-bold text-brand mb-1">Profesional Clínico</div>
                <div className="text-[14px] text-ink-soft leading-relaxed">Diagnostica, trata, ajusta terapias y define planes de cuidado.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
